import { render } from "./Message.vue?vue&type=template&id=c0beb90e"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script